<template>
  <el-select ref="user" v-model="selected" filterable v-loading="loading" :multiple="false"
    :placeholder="$t('selecione-uma-opcao')" @change="update()">
    <el-option v-for="row of tableData" :key="row.id" :label="row.service" :value="row.id"></el-option>
  </el-select>
</template>

<script>
import { ShippingIntegrationService } from "@/services/shipping/shipping.integration.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ShippingIntegrationList",
  data: function () {
    return {
      tableData: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    type: String,
    current: String,
  },
  watch: {
    type: function (v) {
      console.log('watch', v, this.type)
      this.fetch();
    },
    current: function (v) {
      const vm = this;
      vm.selected = vm.$props.current;
    },
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      if (vm.type) {
        ShippingIntegrationService.filter(vm.type)
          .then((response) => {
            vm.tableData = response.records.sort((a, b) => a.service.localeCompare(b.service));
            setTimeout(() => {
              vm.selected = vm.$props.current;
            }, 500);
          })
          .catch((error) => {
            vm.$notify.error({
              title: i18n.tc("erro"),
              message: error,
            });
          })
          .finally(() => (vm.loading = false));
      }
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>